<mf-page title="Editar cuenta de pasarela">
  @if (gatewayBankAccountDto) {
  <mf-gateway-bank-account
    [miPspcId]="gatewayBankAccountDto.holderId!"
    [gatewayBankAccountDto]="gatewayBankAccountDto"
    (close)="close()"
    (save)="save($event)" />
  }
</mf-page>
